/**
 * @generated SignedSource<<a3fc7e83eba827ee2a7905bb8358bf77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentsPanelDeleteCommentMutation$variables = {
  id: string;
};
export type CommentsPanelDeleteCommentMutation$data = {
  readonly Comment_Delete: {
    readonly comment: {
      readonly id: string;
      readonly isDeleted: boolean;
    };
  } | null;
};
export type CommentsPanelDeleteCommentMutation = {
  response: CommentsPanelDeleteCommentMutation$data;
  variables: CommentsPanelDeleteCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteComment",
    "kind": "LinkedField",
    "name": "Comment_Delete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "comment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPanelDeleteCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsPanelDeleteCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3beedf25b72a1115b1ff2b1217e33ae1",
    "id": null,
    "metadata": {},
    "name": "CommentsPanelDeleteCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsPanelDeleteCommentMutation(\n  $id: ID!\n) {\n  Comment_Delete(commentId: $id) {\n    comment {\n      id\n      isDeleted\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c0e4702170108a11d0d22a9a6ff8868";

export default node;
